import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

// Minimal i18n: TR (default) + EN. Add keys as needed; missing keys fall back to the key itself.
const DICT = {
  tr: {
    // Sidebar
    "nav.dashboard": "Dashboard",
    "nav.plans": "Planlar",
    "nav.new_plan": "Yeni Plan",
    "nav.invoices": "Commercial Invoice",
    "nav.products": "Ürün Yönetimi",
    "nav.pallet_types": "Palet Tipleri",
    "nav.recipes": "Reçete Kütüphanesi",
    "nav.test_center": "Test Merkezi",
    "nav.reports": "Raporlar",
    "nav.settings": "Ayarlar",
    "nav.admin_users": "Kullanıcılar",
    "sidebar.account": "Hesap",
    "sidebar.logout": "Çıkış Yap",
    "sidebar.language": "Dil",

    // Common
    "common.save": "Kaydet",
    "common.cancel": "İptal",
    "common.delete": "Sil",
    "common.edit": "Düzenle",
    "common.approve": "Onayla",
    "common.close": "Kapat",
    "common.loading": "Yükleniyor…",
    "common.pdf": "PDF",
    "common.excel": "Excel",
    "common.undo": "Geri Al",

    // Login
    "login.title": "H3POE — Palet Optimizasyonu",
    "login.email": "E-posta",
    "login.password": "Şifre",
    "login.submit": "Giriş Yap",
    "login.name": "Ad Soyad",
    "auth.register_success": "Hesap oluşturuldu, hoş geldiniz!",
    "login.register": "Kayıt Ol",
    "login.have_account": "Hesabınız var mı?",
    "login.no_account": "Hesabınız yok mu?",

    // Dashboard
    "dashboard.title": "Kontrol Paneli",
    "dashboard.today": "Bugünün Planları",
    "dashboard.total_plans": "Toplam Plan",
    "dashboard.recent_plans": "Son Planlar",
    "dashboard.pending": "Bekleyen",
    "dashboard.recent": "Son 5 Plan",

    // Plans
    "plans.title": "Planlar",
    "plans.new_plan": "Yeni Plan",


    // Dashboard
    "dashboard.subtitle": "Sevkiyat performansı ve son planlar",
    "dashboard.new_plan": "Yeni Plan",
    "dashboard.free_quota": "Ücretsiz Plan Kotası",
    "dashboard.quota_full": "Aylık plan kotanız doldu",
    "dashboard.quota_usage": "Bu ay {used} / {limit} plan kullanıldı",
    "dashboard.upgrade_hint": "Sınırsız plan için Pro'ya geçin.",
    "dashboard.upgrade": "Pro'ya Yükselt",
    "dashboard.today_plan": "Bugün Plan",
    "dashboard.today_pallet": "Bugün Palet",
    "dashboard.total_kg": "Toplam Kg",
    "dashboard.total_boxes": "Toplam Kutu",
    "dashboard.view_all": "Tümünü Gör",
    "dashboard.shipment": "Sevkiyat",
    "dashboard.country": "Ülke",
    "dashboard.pallet": "Palet",
    "dashboard.status": "Durum",
    "dashboard.approved": "Onaylı",
    "dashboard.waiting": "Bekliyor",
    "dashboard.no_plan": "Henüz plan yok. İlk planınızı oluşturun.",
    "dashboard.pending_plans": "Bekleyen Planlar",
    "dashboard.pending_desc": "Onay bekleyen sevkiyat sayısı.",
    "dashboard.total_pallet": "Toplam Palet",

    // Plans
    "plans.subtitle": "Kaydedilmiş tüm sevkiyat planları",
    "plans.plan_no": "Plan No",
    "plans.shipment": "Sevkiyat",
    "plans.country": "Ülke",
    "plans.date": "Tarih",
    "plans.pallet": "Palet",
    "plans.fill": "Doluluk",
    "plans.status": "Durum",
    "plans.approved": "Onaylı",
    "plans.waiting": "Bekliyor",
    "plans.edit_title": "Adetleri düzenle & yeniden optimize et",
    "plans.no_plan": "Henüz plan yok.",

    // New Plan
    "newplan.create_title": "Yeni Plan Oluştur",
    "newplan.edit_title": "Planı Düzenle",
    "newplan.create_subtitle": "Sevkiyat bilgileri + ürün adetleri → H3POE optimizasyonu",
    "newplan.edit_subtitle": "Adetleri güncelle, üzerine yaz — plan no aynı kalır",
    "newplan.shipment_info": "Sevkiyat Bilgileri",
    "newplan.shipment_name": "Sevkiyat Adı",
    "newplan.consignee": "Consignee (Alıcı)",
    "newplan.country": "Ülke",
    "newplan.pallet_type": "Palet Tipi",
    "newplan.date": "Tarih",
    "newplan.delivery_address": "Teslimat Adresi",
    "newplan.note": "Not",
    "newplan.product_qty": "Ürün Adetleri",
    "newplan.total": "Toplam",
    "newplan.product_category": "Ürün Kategorisi",
    "newplan.select_category": "— Kategori seçin —",
    "newplan.uncategorized": "Kategorisiz",
    "newplan.no_category_products": "Bu kategoride ürün bulunamadı.",
    "newplan.choose_category": "Ürünleri görmek için kategori seçin.",
    "newplan.calculating": "Hesaplanıyor…",
    "newplan.optimize": "Optimize Et (H3POE)",
    "newplan.reoptimize": "Yeniden Optimize Et & Üzerine Yaz",
    "newplan.result_waiting": "Sonuç bekleniyor",
    "newplan.result_hint": "Ürün adetlerini girin ve Optimize Et butonuna basın.",
    "newplan.pallet_count": "Palet Sayısı",
    "newplan.unplaced": "Yerleşmeyen",
    "newplan.box": "Kutu",
    "newplan.weight": "Ağırlık",
    "newplan.height": "Yükseklik",
    "newplan.fill": "Doluluk",
    "newplan.empty_volume": "Boş Hacim",
    "newplan.save_plan": "Planı Kaydet & Detayı Aç",
    "newplan.suitable_recipes": "Uygun Reçeteler",
    "newplan.recipe": "Reçete",
    "newplan.inspect": "İncele →",
    "newplan.no_product": "En az bir ürün girin",
    "newplan.plan_load_error": "Plan yüklenemedi",
    "newplan.plan_saved": "Plan kaydedildi",

    // Products
    "products.title": "Ürün Yönetimi",
    "products.subtitle": "{products} ürün · {categories} kategori · toplu kategori yönetimi",
    "products.template": "Şablon",
    "products.export_all": "Tümünü Dışa Aktar",
    "products.import_excel": "Excel İçe Aktar",
    "products.new_product": "Yeni Ürün",
    "products.filter": "Filtre",
    "products.all_categories": "Tüm Kategoriler",
    "products.uncategorized": "Kategorisiz",
    "products.category_assignment": "Kategori Atama",
    "products.selected_count": "{n} ürün seçildi",
    "products.assign_category": "Seçilenleri Kategoriye Ata",
    "products.add_category": "+ Kategori Ekle",
    "products.edit_category": "Kategori Düzenle",
    "products.delete_category": "Kategori Sil",
    "products.inch": "İnç",
    "products.category": "Kategori",
    "products.dimensions": "Ölçüler (D×G×Y)",
    "products.package_kg": "Koli kg",
    "products.product_kg": "Ürün kg",
    "products.net_kg": "Net kg",
    "products.price": "Fiyat",
    "products.no_products": "Bu kategoride ürün bulunamadı.",
    "products.edit_product": "Ürünü Düzenle",
    "products.length": "Uzunluk (D)",
    "products.width": "Genişlik (G)",
    "products.height": "Yükseklik (Y)",
    "products.unit_price": "Birim Fiyat (Commercial Invoice için)",
    "products.currency": "Para Birimi",


    // Commercial Invoice
    "invoice.title": "Commercial Invoice",
    "invoice.subtitle": "Onaylı sevkiyattan otomatik ticari fatura üretin — TCMB kuruyla döviz çevirisi opsiyonel",
    "invoice.saved": "Kayıtlı Faturalar",
    "invoice.invoice_no": "Fatura No",
    "invoice.date": "Tarih",
    "invoice.plan_no": "Plan No",
    "invoice.consignee": "Alıcı",
    "invoice.quantity": "Adet",
    "invoice.amount": "Tutar",
    "invoice.status": "Durum",
    "invoice.cancelled": "İptal",
    "invoice.active": "Aktif",
    "invoice.none": "Henüz fatura yok.",
    "invoice.select_approved": "1. Onaylı Sevkiyat Seç",
    "invoice.select_plan": "— Plan seçin —",
    "invoice.no_approved": "Henüz onaylı plan yok.",
    "invoice.details": "2. Sevkiyat Detayları",
    "invoice.auto_no": "boş bırakılırsa otomatik oluşturulur",
    "invoice.currency": "Para Birimi",
    "invoice.convert": "Otomatik döviz çevirisi",
    "invoice.convert_desc": "Ürün fiyatları TCMB satış kuruna göre seçilen para birimine çevrilir",
    "invoice.shipping": "Gönderim Şekli",
    "invoice.other": "Diğer (elle gir)",
    "invoice.carrier": "Carrier (Taşıyıcı)",
    "invoice.seller": "Seller / Exporter",
    "invoice.note": "Not",
    "invoice.create": "Commercial Invoice Oluştur",
    "invoice.creating": "Oluşturuluyor…",
    "invoice.preview": "Fatura Önizleme",
    "invoice.preview_hint": "Bir plan seçin, ürünler otomatik gelecek.",
    "invoice.description": "Açıklama",
    "invoice.unit_price": "Birim Fiyat",
    "invoice.total": "Toplam",
    "invoice.no_price": "FİYAT YOK",
    "invoice.settings": "Ayarlar →",

    // Invoice Detail
    "invoice_detail.loading": "Yükleniyor…",
    "invoice_detail.cancel": "İptal Et",
    "invoice_detail.cancelled": "Bu fatura iptal edilmiştir.",
    "invoice_detail.shipment_info": "Sevkiyat Bilgileri",
    "invoice_detail.shipping": "Gönderim",
    "invoice_detail.pallet": "Palet",
    "invoice_detail.total_amount": "Toplam Tutar",
    "invoice_detail.account_holder": "Hesap Sahibi",

    // Settings
    "settings.title": "Ayarlar",
    "settings.subtitle": "Şirket bilgileri ve banka detayları Packing List ve Commercial Invoice'ta kullanılır",
    "settings.company": "Şirket Bilgileri",
    "settings.company_name": "Şirket Adı",
    "settings.logo": "Logo Ayarları",
    "settings.remove": "Kaldır",
    "settings.small": "Küçük (10mm)",
    "settings.large": "Büyük (20mm)",
    "settings.right": "Sağ",
    "settings.bank_name": "Banka Adı",
    "settings.bank_branch": "Banka Şube",
    "settings.account_holder": "Hesap Sahibi",
    "settings.saved": "Ayarlar kaydedildi",

    // Reports
    "reports.title": "Raporlar",
    "reports.subtitle": "Aylık/yıllık sevkiyat performansı",
    "reports.monthly": "Aylık Palet & Kg",
    "reports.top_products": "En Çok Gönderilen Ürünler",
    "reports.monthly_detail": "Aylık Detay",
    "reports.month": "Ay",
    "reports.plan": "Plan",
    "reports.pallet": "Palet",
    "reports.box": "Kutu",

    // Pallet Types
    "pallets.title": "Palet Tipleri",
    "pallets.subtitle": "Ülke bazlı palet ölçüleri",
    "pallets.new": "Yeni Palet",
    "pallets.code": "Kod",
    "pallets.name": "Ad",
    "pallets.total_h": "Toplam Y",
    "pallets.pallet_h": "Palet Y",
    "pallets.usable_h": "Kullanılabilir Y",
    "pallets.edit": "Palet Düzenle",
    "pallets.length": "Uzunluk",
    "pallets.width": "Genişlik",
    "pallets.total_height": "Toplam Yükseklik",
    "pallets.pallet_height": "Palet Yüksekliği",
    "pallets.usable_height": "Kullanılabilir Y",
    "pallets.tolerance": "Tolerans",

    // Recipes
    "recipes.title": "Reçete Kütüphanesi",
    "recipes.subtitle": "Onaylanmış palet kombinasyonları — gelen siparişlerde otomatik kullanılır",
    "recipes.shipment": "Sevkiyat",
    "recipes.country": "Ülke",
    "recipes.products": "Ürünler",
    "recipes.pallet": "Palet",
    "recipes.fill": "Doluluk",
    "recipes.signature": "İmza (SKU:Adet)",
    "recipes.none": "Henüz reçete yok. Bir planı onaylayarak reçete oluşturun.",

    // Test Center
    "test.title": "Algoritma Test Merkezi",
    "test.subtitle": "Geçmiş doğrulanmış palet düzenlerine karşı H3POE algoritmasının doğruluğunu ölçün",
    "test.pallet_type": "Palet Tipi",
    "test.expected": "Beklenen Palet Sayısı",
    "test.compare": "Karşılaştır",
    "test.comparing": "Karşılaştırılıyor…",
    "test.accuracy": "Doğruluk",
    "test.history": "Geçmiş Testler",
    "test.selected": "{n} seçili",
    "test.bulk_delete": "Toplu Sil",
    "test.deleting": "Siliniyor…",
    "test.date": "Tarih",
    "test.algorithm": "Algoritma",
    "test.diff": "Fark",
    "test.fill": "Doluluk",
    "test.none": "Henüz test yok.",


    // Pack 2 cleanup
    "common.no_data": "Veri yok",
    "settings.save": "Kaydet",
    "settings.address": "Adres",
    "settings.phone": "Telefon",
    "settings.email": "Email",
    "settings.website": "Website",
    "settings.tax_id": "Vergi No / Tax ID",
    "settings.bank_info": "Banka Bilgileri",
    "settings.logo_optional": "Logo (opsiyonel, max 500KB PNG/JPG)",
    "settings.logo_size": "Logo Boyutu",
    "settings.logo_position": "Logo Konumu",
    "settings.medium": "Orta (14mm)",
    "settings.left": "Sol",
    "settings.center": "Orta",
    "settings.logo_help": "Logo, Packing List ve Commercial Invoice PDF'lerinin üst kısmında görünür.",
    "settings.bank_help": "Bu bilgiler Commercial Invoice PDF/Excel dosyalarında otomatik görünecektir.",
    "settings.choose_file": "Dosya Seç",
    "settings.no_file": "Dosya seçilmedi",

    "pallets.tolerance_short": "Tolerans",


    // Admin
    "admin.title": "Kullanıcılar & Abonelikler",
    "admin.subtitle": "Kayıtlı kullanıcıları, rolleri ve abonelik planlarını yönetin",

    "admin.total_interactions": "Toplam Etkileşim",
    "admin.landing_visits": "Landing Ziyareti",
    "admin.price_clicks": "Fiyat Tıkı",
    "admin.cta_clicks": "CTA Tıkı",
    "admin.role": "Rol",
    "admin.subscription": "Abonelik",
    "admin.subscription_status": "Abonelik Durumu",
    "admin.actions": "Aksiyonlar",
    "admin.full_name": "Ad Soyad",
    "admin.reset_info": "Kullanıcıya yeni bir şifre atayın. Kullanıcı bir sonraki girişinde bunu kullanacak.",
    "admin.updated": "Kullanıcı güncellendi",
    "admin.deleted": "Kullanıcı silindi",

    "admin.total": "Toplam",
    "admin.pending_reset": "Bekleyen sıfırlama",
    "admin.loading": "Yükleniyor…",
    "admin.user": "Kullanıcı",
    "admin.status": "Durum",
    "admin.registered": "Kayıt",
    "admin.active": "Aktif",
    "admin.edit": "Düzenle",
    "admin.reset_password": "Şifre Sıfırla",
    "admin.no_users": "Kayıtlı kullanıcı yok.",
    "admin.forgot_requests": "Şifremi Unuttum İstekleri",
    "admin.email": "E-posta",
    "admin.date": "Tarih",
    "admin.action": "Aksiyon",
    "admin.pending": "Bekliyor",
    "admin.completed": "Tamamlandı",
    "admin.assign_password": "Şifre Ata →",
    "admin.no_requests": "Bekleyen istek yok.",
    "admin.role_user": "Kullanıcı",
    "admin.role_admin": "Yönetici",
    "admin.subscription_end": "Abonelik Bitiş Tarihi (ops.)",
    "admin.account_active": "Hesap aktif",
    "admin.new_password": "Yeni Şifre",
    "admin.assign": "Şifreyi Ata",
    "admin.assigning": "Sıfırlanıyor…",

    // Profile
    "profile.title": "Hesap Profili",

    "profile.full_name": "Ad Soyad",
    "profile.role": "Rol",
    "profile.email": "E-posta",
    "profile.timezone": "Zaman Dilimi",

    "profile.subtitle": "Kişisel bilgileri ve güvenlik ayarlarını yönetin",
    "profile.loading": "Yükleniyor…",
    "profile.joined": "Katılım",
    "profile.personal": "Kişisel Bilgiler",
    "profile.email_locked": "E-posta (değiştirilemez)",
    "profile.local_time": "Şu anki yerel saat",
    "profile.save": "Kaydet",
    "profile.saving": "Kaydediliyor…",
    "profile.change_password": "Şifre Değiştir",
    "profile.current_password": "Mevcut Şifre",
    "profile.new_password": "Yeni Şifre",
    "profile.confirm_password": "Yeni Şifre (Tekrar)",
    "profile.password_hint": "En az 6 karakter. Değişiklikten sonra tekrar giriş gerekmez.",
    "profile.update_password": "Şifreyi Güncelle",
    "profile.updating": "Güncelleniyor…",

    // Login/Register
    "auth.login_tab": "Giriş",
    "auth.register_tab": "Kayıt Ol",
    "auth.forgot_tab": "Şifremi Unuttum",
    "auth.hero": "Palet planı yerine mühendislik.",
    "auth.hero_desc": "TV ekran koruyucularınızın ihracatı için en az palet, en yüksek doluluk ve gerçek fiziksel yerleşim doğruluğu.",
    "auth.forgot": "Şifremi Unuttum?",
    "auth.new_account": "Yeni Hesap",
    "auth.free_try": "Ücretsiz Dene",
    "auth.password": "Şifre",
    "auth.password_again": "Şifre (Tekrar)",
    "auth.create_account": "Hesap Oluştur",
    "auth.creating": "Oluşturuluyor…",
    "auth.terms": "Devam ederek Kullanım Koşulları'nı kabul etmiş sayılırsınız.",
    "auth.recovery": "Şifre Kurtarma",
    "auth.recovery_desc": "E-postanızı girin. Yönetici sizinle iletişime geçecek.",
    "auth.request_received": "İsteğiniz alındı. Yönetici en kısa sürede şifrenizi sıfırlayacaktır.",
    "auth.send_request": "İstek Gönder",
    "auth.sending": "Gönderiliyor…",
    "auth.sent": "Gönderildi ✓",
    "auth.back_login": "← Girişe dön",
    "auth.google": "Google ile Giriş Yap",

    // Reset / Verify
    "reset.title": "Şifre Sıfırlama",
    "reset.new_password": "Yeni Şifre Belirle",
    "reset.desc": "Aşağıya yeni şifrenizi girin. En az 6 karakter olmalı.",
    "reset.invalid": "Sıfırlama bağlantısı geçersiz.",
    "reset.success": "Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz…",
    "reset.update": "Şifreyi Güncelle",
    "reset.back": "Girişe dön",

    "verify.title": "E-posta Doğrulama",
    "verify.verifying": "E-posta doğrulanıyor…",
    "verify.success": "E-postanız doğrulandı!",
    "verify.activated": "hesabınız etkinleştirildi. Şimdi giriş yapabilirsiniz.",
    "verify.redirect": "Otomatik yönlendiriliyorsunuz…",
    "verify.failed": "Doğrulama Başarısız",
    "verify.back": "Girişe Dön",

    // Components
    "layer.show_all": "Tümünü Göster",
    "layer.total_h": "Toplam Y",
    "layer.total_kg": "Toplam KG",
    "layer.show_3d": "3D'de göster",
    "layer.hide_3d": "3D'de gizle",
    "layer.no_boxes": "Henüz kutu yok",
    "layer.top_view": "Katmanın Üstten Görünüşü",
    "layer.click_box": "Bir kutuya tıklayın",

    "pallet3d.drag_on": "🎯 Sürükleme AÇIK",
    "pallet3d.drag": "Sürükle-Bırak",
    "pallet3d.height": "Yükseklik",
    "pallet3d.weight": "Ağırlık",

    "upgrade.quota_full": "Aylık Kotanız Doldu",
    "upgrade.title": "Pro'ya Yükseltin & Sınırsız Plan Oluşturun",
    "upgrade.current_plan": "Şu anki plan",
    "upgrade.recipe": "Reçete kütüphanesi",
    "upgrade.unlimited": "Sınırsız plan",
    "upgrade.priority": "Öncelikli destek",
    "upgrade.recommended": "Önerilen",
    "upgrade.button": "Pro'ya Yükselt",
    "upgrade.later": "Daha sonra hatırlat",

    "sidebar.management": "Yönetim",

    "final.loading": "Yükleniyor",
    "final.save": "Kaydet",
    "final.cancel": "İptal",
    "final.delete_success": "Silindi",
    "final.delete_confirm": "Silinsin mi?",
    "final.download_failed": "İndirme başarısız",

    "final.profile_name_required": "Ad boş olamaz",
    "final.profile_updated": "Profil güncellendi",
    "final.all_fields": "Tüm alanları doldurun",
    "final.password_min": "Yeni şifre en az 6 karakter olmalı",
    "final.password_mismatch": "Yeni şifre eşleşmiyor",
    "final.password_updated": "Şifre güncellendi",

    "final.test_need_product": "En az bir ürün girin",
    "final.test_pallet_type": "Palet Tipi",
    "final.test_expected": "Beklenen Palet Sayısı",
    "final.test_comparing": "Karşılaştırılıyor",
    "final.selected": "seçili",

    "final.reset_invalid_token": "Sıfırlama bağlantısı geçersiz — token eksik.",
    "final.reset_min": "Şifre en az 6 karakter olmalı",
    "final.reset_mismatch": "Şifreler eşleşmiyor",
    "final.reset_done": "Şifreniz güncellendi",

    "final.google_success": "Google ile giriş başarılı",
    "final.google_failed": "Google girişi başarısız oldu",
    "final.google_verifying": "Google oturumu doğrulanıyor…",

    "final.admin.password_min": "Şifre en az 6 karakter",
    "final.admin.end": "Bitiş",
    "final.admin.assign": "Şifre Ata →",
    "final.admin.edit": "Düzenle",
    "final.admin.active": "Hesap aktif",
    "final.admin.cancel": "İptal",
    "final.admin.save": "Kaydet",
    "final.admin.reset": "Şifre Sıfırla",

    "final.recipe_delete": "Reçete silinsin mi?",

    "final.invoice.cancel": "İptal Et",
    "final.invoice.cancelled_info": "Bu fatura iptal edilmiştir.",
    "final.invoice.copy_hint": "Yeni bir belge için Kopyala seçeneği kullanılabilir.",
    "final.invoice.mixed_currency": "Karışık para birimi",
    "final.invoice.description": "Açıklama",
    "final.invoice.edit_no": "Fatura no düzenle",
    "final.invoice.product_management": "Ürün Yönetimi",
    "final.invoice.missing_prices": "Bazı ürünlerde fiyat tanımlı değil.",
    "final.invoice.enter_prices": "sayfasından birim fiyatları girin.",

    "final.dashboard.quota_full": "Aylık plan kotanız doldu",
    "final.dashboard.free_quota": "Ücretsiz Plan Kotası",
    "final.dashboard.this_month": "Bu ay",
    "final.dashboard.used": "plan kullanıldı",
    "final.dashboard.pro_hint": "Sınırsız plan için Pro'ya geçin.",
    "final.dashboard.upgrade": "Pro'ya Yükselt",

    "final.verify_missing": "Doğrulama token'ı eksik.",
    "final.verify_failed": "Doğrulama başarısız oldu.",
    "final.verify.for": "için",

    "final.login_success": "Giriş başarılı",
    "final.login_min": "Şifre en az 6 karakter olmalı",
    "final.login_mismatch": "Şifreler eşleşmiyor",
    "final.login.request": "İsteğiniz alındı",

    "final.products.new_category": "Yeni kategori adı:",
    "final.products.select_category": "Önce bir kategori seçin",
    "final.products.category_name": "Kategori adı:",
    "final.products.updated": "Kategori güncellendi",
    "final.products.select_product": "En az bir ürün seçin",
    "final.products.edit": "Düzenle",
    "final.products.package_kg": "Koli kg",
    "final.products.product_kg": "Ürün kg",
    "final.products.net_kg": "Net kg",
    "final.products.unit_price": "Birim Fiyat (Commercial Invoice için)",
    "final.products.select_all": "Tüm ürünleri seç",

    "final.layer.show_all": "Tümünü Göster",

    "final.pallet3d.drag_on_title": "Sürükle-bırak açık — kapatmak için tıkla",
    "final.pallet3d.drag_title": "Kutuları XY düzleminde sürükle-bırak",
    "final.pallet3d.box": "Kutu",

    "final.upgrade.desc": "Ücretsiz planınızda aylık plan hakkınız sınırlıdır. Pro planla sınırsız plan, reçete önerileri ve tüm özellikleri kullanabilirsiniz.",



    "final4b.newplan.match_exact": "Tam Eşleşme",
    "final4b.newplan.match_multiple": "Katlı Eşleşme",
    "final4b.newplan.match_partial": "Kısmi Eşleşme",
    "final4b.newplan.recipe_apply": "Reçete uygulanacak",
    "final4b.newplan.press_optimize": "Optimize Et'e basın",
    "final4b.newplan.recipes_applied": "reçete uygulandı",
    "final4b.newplan.optimization_done": "Optimizasyon tamamlandı",
    "final4b.newplan.reopt_confirm": "Bu plan yeni adetlerle yeniden optimize edilecek ve ÜZERİNE YAZILACAK. Devam?",
    "final4b.newplan.plan_updated": "Plan güncellendi",
    "final4b.newplan.suitable_count": "Bu siparişe uygun onaylı reçete sayısı",
    "final4b.newplan.best_match": "En iyi eşleşme",
    "final4b.newplan.inspect": "İncele →",
    "final4b.newplan.enter_qty": "Ürün adetlerini girin ve",
    "final4b.newplan.press_button": "butonuna basın.",
    "final4b.newplan.reoptimize": "Yeniden Optimize Et",
    "final4b.newplan.optimize": "Optimize Et",
    "final4b.newplan.save_open": "Planı Kaydet & Detayı Aç",
    "final4b.newplan.recipe": "Reçete",
    "final4b.newplan.consumed": "Tüketilecek",

    "final4b.detail.loading": "Yükleniyor",
    "final4b.detail.undo_none": "Geri alınacak işlem yok",
    "final4b.detail.rotation_not_fit": "Rotasyon sonrası kutu palete sığmıyor",
    "final4b.detail.rotation_no_space": "Rotasyon sonrası uygun yer bulunamadı",
    "final4b.detail.outside": "Palet sınırı dışına çıkıyor",
    "final4b.detail.collision": "Başka kutuyla çakışıyor",
    "final4b.detail.target_not_fit": "Hedef palete sığmıyor",
    "final4b.detail.box_moved": "Kutu taşındı",
    "final4b.detail.remove_box_confirm": "Bu kutu paletten kaldırılacak, devam?",
    "final4b.detail.only_empty": "Sadece boş paletler silinebilir",
    "final4b.detail.delete_pallet": "paleti silinsin mi?",
    "final4b.detail.pallet_deleted": "Palet silindi",
    "final4b.detail.orientation_default": "D×G×Y (varsayılan)",
    "final4b.detail.orientation_side": "D×Y×G (yan yatık)",
    "final4b.detail.orientation_rotated": "G×D×Y (döndürülmüş)",
    "final4b.detail.select_product_error": "Bir ürün seçin",
    "final4b.detail.product_not_found": "Ürün bulunamadı",
    "final4b.detail.no_rotation_fit": "Kutu, 6 rotasyonun hiçbirinde palete sığmadı — Yeni Palet ekleyin",
    "final4b.detail.try_other": "yönünde palete sığmadı, farklı yön deneyin veya Otomatik seçin",
    "final4b.detail.box_added": "Kutu eklendi",
    "final4b.detail.box_positioned": "Kutu yeni konuma taşındı",
    "final4b.detail.boxes_rotated": "kutu döndürüldü (Z ekseni)",
    "final4b.detail.save_first": "Önce değişiklikleri kaydedin",
    "final4b.detail.approved": "Plan onaylandı ve Reçete olarak kaydedildi",
    "final4b.detail.manual_saved": "Manuel değişiklikler kaydedildi",
    "final4b.detail.save": "Kaydet",
    "final4b.detail.empty": "Boş",
    "final4b.detail.delete_empty": "Boş paleti sil",
    "final4b.detail.mouse_help": "Kutuya tıkla · Shift/Ctrl + tıkla ile çoklu seç · Fare ile döndür",
    "final4b.detail.pallet": "Palet",
    "final4b.detail.boxes_selected": "kutu seçildi",
    "final4b.detail.bulk_rotate": "Toplu Döndür (Z)",
    "final4b.detail.clear_selection": "Seçimi Temizle",
    "final4b.detail.metrics": "Palet Metrikleri",
    "final4b.detail.pallet_no": "Palet No",
    "final4b.detail.box": "Kutu",
    "final4b.detail.height": "Yükseklik",
    "final4b.detail.weight": "Ağırlık",
    "final4b.detail.empty_volume": "Boş Hacim",
    "final4b.detail.selected_box": "Seçili Kutu",
    "final4b.detail.rotate": "Döndür (90°)",
    "final4b.detail.move_position": "Konum Kaydır",
    "final4b.detail.move_pallet": "Başka Palete Taşı",
    "final4b.detail.select_target": "Hedef seç",
    "final4b.detail.delete_box": "Kutuyu Sil",
    "final4b.detail.select_box_manual": "Manuel düzenlemek için kutu seçin",
    "final4b.detail.orientation": "Yönlendirme (Rotasyon)",
    "final4b.detail.auto_help": "Sistem ilk uygun boş noktaya yerleştirir. Otomatik seçili ise 6 farklı yönü sırayla dener.",
    "final4b.detail.box_list": "Kutu Listesi",
    "final4b.detail.add_pallet": "Yeni Palet Ekle",
    "final4b.detail.select_pallet_type": "Palet tipini seçin (kullanılabilir yükseklik dikkate alınır):",
    "final4b.detail.plan_default": "Plan Varsayılan",
    "final4b.detail.usable": "kullanılabilir",
    "final4b.detail.no_pallet_type": "Palet tipi bulunamadı",

    "final4b.detail.bulk_delete": "Toplu Sil",
    "final4b.detail.summary": "Bu Palette Ürün Adetleri",
    "final4b.detail.add_box": "Bu Palete Kutu Ekle",
    "final4b.detail.download_failed": "İndirme başarısız",
    "final4b.detail.automatic": "Otomatik",
    "final4b.newplan.recipe_badge": "RÇT",
    "final4b.newplan.consignee_example": "Örn. ACME Ltd. — London Branch",




    "landing.nav.home": "Ana Sayfa",
    "landing.nav.features": "Özellikler",
    "landing.nav.how": "Nasıl Çalışır?",
    "landing.nav.sectors": "Sektörel Çözümler",
    "landing.nav.pricing": "Fiyatlandırma",
    "landing.nav.demo": "Demo",
    "landing.nav.about": "Hakkımızda",
    "landing.nav.contact": "İletişim",

    "landing.theme": "Tema değiştir",
    "landing.login": "Giriş Yap",
    "landing.free_try": "Ücretsiz Dene",

    "landing.hero.badge": "H3POE Algoritması · 3D Fiziksel Yerleşim",
    "landing.hero.title1": "Palet planı yerine",
    "landing.hero.title2": "mühendislik.",
    "landing.hero.desc": "TV ekran koruyucularınızın ihracatı için en az palet, en yüksek doluluk ve gerçek fiziksel yerleşim doğruluğu. Sipariş girin, sistem PDF'e kadar üretsin.",
    "landing.hero.try": "Ücretsiz Deneyin",
    "landing.hero.demo": "Demo İzle",
    "landing.hero.fit": "✓ 3 Palete Sığdı",

    "landing.features.eyebrow": "Özellikler",
    "landing.features.title": "İhracatın her adımı, tek platformda",
    "landing.features.h3poe.title": "H3POE Optimizasyon Motoru",

    "landing.features.docs.text2": "Profesyonel Packing List ve Commercial Invoice şablonları. UTF-8, ₺ desteği ve QR kodlu paletler.",
    "landing.features.test.text2": "Algoritmanızın doğruluğunu geçmiş sevkiyatlara karşı ölçün. Farkları raporlayın ve sürekli iyileştirin.",

    "landing.sectors.electronics.title2": "Elektronik & Tüketici",
    "landing.sectors.electronics.text2": "TV ekran koruyucular, tabletler ve ekipmanlar. Kırılganlık kontrolü ve üst üste destek yüzdesi.",
    "landing.sectors.retail.text2": "Karma SKU'lu paletler. Reçete sistemiyle mağaza siparişlerini saniyeler içinde planlayın.",
    "landing.sectors.factory.title2": "Üretim & Fabrika",
    "landing.sectors.factory.text2": "Üretim çıkışından doğrudan ihracata. Toplu Excel import ile stok senkronizasyonu.",
    "landing.sectors.export.text2": "UK/USA + EU palet tipleri, INCOTERMS ve Consignee desteği. Konteyner planlamasına hazır.",

    "landing.about.p2b": "Ekibimiz, gerçek sevkiyat verilerini analiz ederek Extreme Point tabanlı bir 3D bin-packing motoru ve reçete tabanlı önerici sistem geliştirdi. Sistem, palet planlama sürecini önemli ölçüde hızlandırmak için tasarlandı.",

    "landing.contact.address_value": "Maslak Mah. Büyükdere Cad., İstanbul",

    "landing.features.h3poe.text": "Extreme Point tabanlı 3D bin-packing, 4 strateji karşılaştırması, 6 rotasyon denemesi. En az palet, en yüksek doluluk.",
    "landing.features.recipe.title": "Reçete Sistemi",
    "landing.features.recipe.text": "Onaylanan planlar tekrar kullanılabilir reçete olur. Aynı sipariş geldiğinde saniyede uygulanır.",
    "landing.features.docs.title": "İhracat Belgeleri",
    "landing.features.docs.text": "Profesyonel Packing List ve Commercial Invoice şablonları. UTF-8, ₺ desteği, QR kodlu paletler.",
    "landing.features.test.title": "Test Merkezi",
    "landing.features.test.text": "Algoritmanızın doğruluğunu geçmiş sevkiyatlara karşı ölçün. Farkı raporlayın, sürekli iyileştirin.",
    "landing.features.manual.title": "Manuel 3D Düzenleyici",
    "landing.features.manual.text": "Sürükle-bırak, kilitli kutu, katman gizleme ve çoklu seçim ile toplu döndürme/silme.",
    "landing.features.fx.title": "Otomatik Döviz Kuru",
    "landing.features.fx.text": "TCMB kurlarıyla fatura fiyatlarını otomatik çevirin. Karışık para birimi uyarıları alın.",

    "landing.how.eyebrow": "Nasıl Çalışır?",
    "landing.how.title": "4 adımda ihracata hazır",
    "landing.how.1.title": "Sipariş Girin",
    "landing.how.1.text": "Ürünleri ve miktarları girin, palet tipini seçin.",
    "landing.how.2.title": "Optimize Edin",
    "landing.how.2.text": "H3POE algoritması saniyeler içinde 3D fiziksel yerleşimi üretir.",
    "landing.how.3.title": "İnceleyin & Düzenleyin",
    "landing.how.3.text": "3D görüntüde inceleyin, sürükle-bırak ile manuel ayar yapın.",
    "landing.how.4.title": "PDF/Excel Alın",
    "landing.how.4.text": "Packing List, Commercial Invoice ve QR kod etiketlerini indirin.",

    "landing.sectors.eyebrow": "Sektörel Çözümler",
    "landing.sectors.title": "Her ihracata uygun",
    "landing.sectors.electronics.title": "Elektronik & Tüketici",
    "landing.sectors.electronics.text": "TV ekran koruyucular, tabletler ve ekipmanlar. Kırılganlık kontrolü ve üst üste destek yüzdesi.",
    "landing.sectors.retail.title": "Perakende & Dağıtım",
    "landing.sectors.retail.text": "Karma SKU'lu paletler. Reçete sistemiyle mağaza siparişlerini saniyeler içinde planlayın.",
    "landing.sectors.factory.title": "Üretim & Fabrika",
    "landing.sectors.factory.text": "Üretim çıkışından doğrudan ihracata. Toplu Excel import ile stok senkronizasyonu.",
    "landing.sectors.export.title": "İhracat & Lojistik",
    "landing.sectors.export.text": "UK/USA + EU palet tipleri, INCOTERMS ve Consignee desteği. Konteyner planlamasına hazır.",

    "landing.pricing.eyebrow": "Fiyatlandırma",
    "landing.pricing.title": "Kullanıcı başına adil fiyat",
    "landing.pricing.free": "Başlangıç",
    "landing.pricing.free_price": "₺0",
    "landing.pricing.free_period": "Ücretsiz",
    "landing.pricing.free_f1": "1 aktif plan/ay",
    "landing.pricing.free_f2": "1 kullanıcı",
    "landing.pricing.free_f3": "PDF export",
    "landing.pricing.free_f4": "TR arayüz",
    "landing.pricing.free_cta": "Ücretsiz Dene",
    "landing.pricing.pro_f1": "Sınırsız plan",
    "landing.pricing.pro_f2": "5 kullanıcı",
    "landing.pricing.pro_f3": "Commercial Invoice",
    "landing.pricing.pro_f4": "QR kod & TCMB kuru",
    "landing.pricing.pro_f5": "Reçete sistemi",
    "landing.pricing.pro_f6": "Öncelikli destek",
    "landing.pricing.pro_cta": "Hemen Başla",
    "landing.pricing.enterprise": "Kurumsal",
    "landing.pricing.custom": "Özel",
    "landing.pricing.quote": "Teklif",
    "landing.pricing.ent_f1": "Sınırsız kullanıcı",
    "landing.pricing.ent_f2": "Kendi domaininiz",
    "landing.pricing.ent_f3": "SSO/SAML",
    "landing.pricing.ent_f4": "API erişimi",
    "landing.pricing.ent_f5": "Özel eğitim",
    "landing.pricing.ent_cta": "İletişime Geç",
    "landing.pricing.popular": "Popüler",

    "landing.demo.eyebrow": "Demo",
    "landing.demo.title": "Kendi gözünüzle görün",
    "landing.demo.open": "Demo'yu Aç",

    "landing.about.eyebrow": "Hakkımızda",
    "landing.about.title": "Palet planlaması hâlâ Excel'de olmamalı",
    "landing.about.p1": "H3POE, ihracat operasyonlarını hızlandırmak için doğdu. Manuel palet planlaması saatler alabilir ve operasyonel hatalara yol açabilir.",
    "landing.about.p2": "Gerçek sevkiyat verilerinden yararlanan Extreme Point tabanlı 3D bin-packing motoru ve reçete tabanlı öneri sistemi ile planlama süreci önemli ölçüde hızlandırılabilir.",
    "landing.about.metric1": "Palet Optimize",
    "landing.about.metric2": "Ort. Plan Süresi",
    "landing.about.metric3": "Aktif Şirket",

    "landing.contact.eyebrow": "İletişim",
    "landing.contact.title": "Sorularınız için bize yazın",
    "landing.contact.address": "Adres",
    "landing.contact.support": "Canlı Destek",
    "landing.contact.support_hours": "Pzt-Cum 09:00-18:00",

    "landing.footer.rights": "Tüm hakları saklıdır.",

    "landing.form.name": "Adınız",
    "landing.form.message": "Mesajınız",
    "landing.form.sent": "Mesajınız Alındı ✓",
    "landing.form.send": "Gönder",


    // Plan Detail
    "plandetail.dirty": "Kaydedilmemiş değişiklikler",
    "plandetail.approve_recipe": "Onayla & Reçete",
    "plandetail.create_invoice": "Fatura Oluştur",
    "plandetail.pallets": "Paletler",
    "plandetail.new_pallet": "Yeni Palet",
    "plandetail.add_box": "Bu Palete Kutu Ekle",
    "plandetail.select_product": "Ürün seçin…",
    "plandetail.summary": "Bu Palette Ürün Adetleri",
    "plandetail.hint_click": "Kutuya tıkla · Shift/Ctrl + tıkla ile çoklu seç · Fare ile döndür",
    "plandetail.selected_boxes": "{n} kutu seçildi",
    "plandetail.bulk_rotate": "Toplu Döndür (Z)",
    "plandetail.bulk_delete": "Toplu Sil",
    "plandetail.clear_selection": "Seçimi Temizle",
  },
  en: {
    // Sidebar
    "nav.dashboard": "Dashboard",
    "nav.plans": "Plans",
    "nav.new_plan": "New Plan",
    "nav.invoices": "Commercial Invoice",
    "nav.products": "Product Management",
    "nav.pallet_types": "Pallet Types",
    "nav.recipes": "Recipe Library",
    "nav.test_center": "Test Center",
    "nav.reports": "Reports",
    "nav.settings": "Settings",
    "nav.admin_users": "Users",
    "sidebar.account": "Account",
    "sidebar.logout": "Log out",
    "sidebar.language": "Language",

    // Common
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.approve": "Approve",
    "common.close": "Close",
    "common.loading": "Loading…",
    "common.pdf": "PDF",
    "common.excel": "Excel",
    "common.undo": "Undo",

    // Login
    "login.title": "H3POE — Pallet Optimization",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.name": "Full name",
    "auth.register_success": "Account created, welcome!",
    "login.register": "Register",
    "login.have_account": "Already have an account?",
    "login.no_account": "Don't have an account?",

    // Dashboard
    "dashboard.title": "Dashboard",
    "dashboard.today": "Today's Plans",
    "dashboard.total_plans": "Total Plans",
    "dashboard.recent_plans": "Recent Plans",
    "dashboard.pending": "Pending",
    "dashboard.recent": "Last 5 Plans",

    // Plans
    "plans.title": "Plans",
    "plans.new_plan": "New Plan",


    // Dashboard
    "dashboard.subtitle": "Shipment performance and recent plans",
    "dashboard.new_plan": "New Plan",
    "dashboard.free_quota": "Free Plan Quota",
    "dashboard.quota_full": "Your monthly plan quota is full",
    "dashboard.quota_usage": "{used} / {limit} plans used this month",
    "dashboard.upgrade_hint": "Upgrade to Pro for unlimited plans.",
    "dashboard.upgrade": "Upgrade to Pro",
    "dashboard.today_plan": "Plans Today",
    "dashboard.today_pallet": "Pallets Today",
    "dashboard.total_kg": "Total Kg",
    "dashboard.total_boxes": "Total Boxes",
    "dashboard.view_all": "View All",
    "dashboard.shipment": "Shipment",
    "dashboard.country": "Country",
    "dashboard.pallet": "Pallet",
    "dashboard.status": "Status",
    "dashboard.approved": "Approved",
    "dashboard.waiting": "Pending",
    "dashboard.no_plan": "No plans yet. Create your first plan.",
    "dashboard.pending_plans": "Pending Plans",
    "dashboard.pending_desc": "Number of shipments awaiting approval.",
    "dashboard.total_pallet": "Total Pallets",

    // Plans
    "plans.subtitle": "All saved shipment plans",
    "plans.plan_no": "Plan No",
    "plans.shipment": "Shipment",
    "plans.country": "Country",
    "plans.date": "Date",
    "plans.pallet": "Pallet",
    "plans.fill": "Fill Rate",
    "plans.status": "Status",
    "plans.approved": "Approved",
    "plans.waiting": "Pending",
    "plans.edit_title": "Edit quantities & re-optimize",
    "plans.no_plan": "No plans yet.",

    // New Plan
    "newplan.create_title": "Create New Plan",
    "newplan.edit_title": "Edit Plan",
    "newplan.create_subtitle": "Shipment details + product quantities → H3POE optimization",
    "newplan.edit_subtitle": "Update quantities and overwrite — plan number remains unchanged",
    "newplan.shipment_info": "Shipment Information",
    "newplan.shipment_name": "Shipment Name",
    "newplan.consignee": "Consignee",
    "newplan.country": "Country",
    "newplan.pallet_type": "Pallet Type",
    "newplan.date": "Date",
    "newplan.delivery_address": "Delivery Address",
    "newplan.note": "Note",
    "newplan.product_qty": "Product Quantities",
    "newplan.total": "Total",
    "newplan.product_category": "Product Category",
    "newplan.select_category": "— Select category —",
    "newplan.uncategorized": "Uncategorized",
    "newplan.no_category_products": "No products found in this category.",
    "newplan.choose_category": "Select a category to view products.",
    "newplan.calculating": "Calculating…",
    "newplan.optimize": "Optimize (H3POE)",
    "newplan.reoptimize": "Re-optimize & Overwrite",
    "newplan.result_waiting": "Waiting for results",
    "newplan.result_hint": "Enter product quantities and click Optimize.",
    "newplan.pallet_count": "Pallet Count",
    "newplan.unplaced": "Unplaced",
    "newplan.box": "Boxes",
    "newplan.weight": "Weight",
    "newplan.height": "Height",
    "newplan.fill": "Fill Rate",
    "newplan.empty_volume": "Empty Volume",
    "newplan.save_plan": "Save Plan & Open Details",
    "newplan.suitable_recipes": "Matching Recipes",
    "newplan.recipe": "Recipe",
    "newplan.inspect": "Review →",
    "newplan.no_product": "Enter at least one product",
    "newplan.plan_load_error": "Plan could not be loaded",
    "newplan.plan_saved": "Plan saved",

    // Products
    "products.title": "Product Management",
    "products.subtitle": "{products} products · {categories} categories · bulk category management",
    "products.template": "Template",
    "products.export_all": "Export All",
    "products.import_excel": "Import Excel",
    "products.new_product": "New Product",
    "products.filter": "Filter",
    "products.all_categories": "All Categories",
    "products.uncategorized": "Uncategorized",
    "products.category_assignment": "Category Assignment",
    "products.selected_count": "{n} products selected",
    "products.assign_category": "Assign Selected to Category",
    "products.add_category": "+ Add Category",
    "products.edit_category": "Edit Category",
    "products.delete_category": "Delete Category",
    "products.inch": "Inch",
    "products.category": "Category",
    "products.dimensions": "Dimensions (L×W×H)",
    "products.package_kg": "Package kg",
    "products.product_kg": "Product kg",
    "products.net_kg": "Net kg",
    "products.price": "Price",
    "products.no_products": "No products found in this category.",
    "products.edit_product": "Edit Product",
    "products.length": "Length (L)",
    "products.width": "Width (W)",
    "products.height": "Height (H)",
    "products.unit_price": "Unit Price (for Commercial Invoice)",
    "products.currency": "Currency",


    // Commercial Invoice
    "invoice.title": "Commercial Invoice",
    "invoice.subtitle": "Automatically generate a commercial invoice from an approved shipment — optional FX conversion using TCMB rates",
    "invoice.saved": "Saved Invoices",
    "invoice.invoice_no": "Invoice No",
    "invoice.date": "Date",
    "invoice.plan_no": "Plan No",
    "invoice.consignee": "Consignee",
    "invoice.quantity": "Quantity",
    "invoice.amount": "Amount",
    "invoice.status": "Status",
    "invoice.cancelled": "Cancelled",
    "invoice.active": "Active",
    "invoice.none": "No invoices yet.",
    "invoice.select_approved": "1. Select Approved Shipment",
    "invoice.select_plan": "— Select plan —",
    "invoice.no_approved": "No approved plans yet.",
    "invoice.details": "2. Shipment Details",
    "invoice.auto_no": "leave blank to generate automatically",
    "invoice.currency": "Currency",
    "invoice.convert": "Automatic currency conversion",
    "invoice.convert_desc": "Product prices are converted using TCMB selling rates",
    "invoice.shipping": "Shipping Method",
    "invoice.other": "Other (enter manually)",
    "invoice.carrier": "Carrier",
    "invoice.seller": "Seller / Exporter",
    "invoice.note": "Note",
    "invoice.create": "Create Commercial Invoice",
    "invoice.creating": "Creating…",
    "invoice.preview": "Invoice Preview",
    "invoice.preview_hint": "Select a plan and products will be loaded automatically.",
    "invoice.description": "Description",
    "invoice.unit_price": "Unit Price",
    "invoice.total": "Total",
    "invoice.no_price": "NO PRICE",
    "invoice.settings": "Settings →",

    // Invoice Detail
    "invoice_detail.loading": "Loading…",
    "invoice_detail.cancel": "Cancel Invoice",
    "invoice_detail.cancelled": "This invoice has been cancelled.",
    "invoice_detail.shipment_info": "Shipment Information",
    "invoice_detail.shipping": "Shipping",
    "invoice_detail.pallet": "Pallet",
    "invoice_detail.total_amount": "Total Amount",
    "invoice_detail.account_holder": "Account Holder",

    // Settings
    "settings.title": "Settings",
    "settings.subtitle": "Company and bank details are used in Packing List and Commercial Invoice documents",
    "settings.company": "Company Information",
    "settings.company_name": "Company Name",
    "settings.logo": "Logo Settings",
    "settings.remove": "Remove",
    "settings.small": "Small (10mm)",
    "settings.large": "Large (20mm)",
    "settings.right": "Right",
    "settings.bank_name": "Bank Name",
    "settings.bank_branch": "Bank Branch",
    "settings.account_holder": "Account Holder",
    "settings.saved": "Settings saved",

    // Reports
    "reports.title": "Reports",
    "reports.subtitle": "Monthly/yearly shipment performance",
    "reports.monthly": "Monthly Pallets & Kg",
    "reports.top_products": "Most Shipped Products",
    "reports.monthly_detail": "Monthly Detail",
    "reports.month": "Month",
    "reports.plan": "Plan",
    "reports.pallet": "Pallet",
    "reports.box": "Box",

    // Pallet Types
    "pallets.title": "Pallet Types",
    "pallets.subtitle": "Country-based pallet dimensions",
    "pallets.new": "New Pallet",
    "pallets.code": "Code",
    "pallets.name": "Name",
    "pallets.total_h": "Total H",
    "pallets.pallet_h": "Pallet H",
    "pallets.usable_h": "Usable H",
    "pallets.edit": "Edit Pallet",
    "pallets.length": "Length",
    "pallets.width": "Width",
    "pallets.total_height": "Total Height",
    "pallets.pallet_height": "Pallet Height",
    "pallets.usable_height": "Usable Height",
    "pallets.tolerance": "Tolerance",

    // Recipes
    "recipes.title": "Recipe Library",
    "recipes.subtitle": "Approved pallet combinations — automatically reused for incoming orders",
    "recipes.shipment": "Shipment",
    "recipes.country": "Country",
    "recipes.products": "Products",
    "recipes.pallet": "Pallet",
    "recipes.fill": "Fill Rate",
    "recipes.signature": "Signature (SKU:Qty)",
    "recipes.none": "No recipes yet. Approve a plan to create a recipe.",

    // Test Center
    "test.title": "Algorithm Test Center",
    "test.subtitle": "Measure H3POE accuracy against previously verified pallet layouts",
    "test.pallet_type": "Pallet Type",
    "test.expected": "Expected Pallet Count",
    "test.compare": "Compare",
    "test.comparing": "Comparing…",
    "test.accuracy": "Accuracy",
    "test.history": "Test History",
    "test.selected": "{n} selected",
    "test.bulk_delete": "Bulk Delete",
    "test.deleting": "Deleting…",
    "test.date": "Date",
    "test.algorithm": "Algorithm",
    "test.diff": "Difference",
    "test.fill": "Fill Rate",
    "test.none": "No tests yet.",


    // Pack 2 cleanup
    "common.no_data": "No data",
    "settings.save": "Save",
    "settings.address": "Address",
    "settings.phone": "Phone",
    "settings.email": "Email",
    "settings.website": "Website",
    "settings.tax_id": "Tax ID",
    "settings.bank_info": "Bank Information",
    "settings.logo_optional": "Logo (optional, max 500KB PNG/JPG)",
    "settings.logo_size": "Logo Size",
    "settings.logo_position": "Logo Position",
    "settings.medium": "Medium (14mm)",
    "settings.left": "Left",
    "settings.center": "Center",
    "settings.logo_help": "The logo appears at the top of Packing List and Commercial Invoice PDFs.",
    "settings.bank_help": "This information will automatically appear in Commercial Invoice PDF/Excel files.",
    "settings.choose_file": "Choose File",
    "settings.no_file": "No file chosen",

    "pallets.tolerance_short": "Tolerance",


    // Admin
    "admin.title": "Users & Subscriptions",
    "admin.subtitle": "Manage registered users, roles and subscription plans",

    "admin.total_interactions": "Total Interactions",
    "admin.landing_visits": "Landing Visits",
    "admin.price_clicks": "Pricing Clicks",
    "admin.cta_clicks": "CTA Clicks",
    "admin.role": "Role",
    "admin.subscription": "Subscription",
    "admin.subscription_status": "Subscription Status",
    "admin.actions": "Actions",
    "admin.full_name": "Full Name",
    "admin.reset_info": "Assign a new password to this user. The user will use it on their next sign-in.",
    "admin.updated": "User updated",
    "admin.deleted": "User deleted",

    "admin.total": "Total",
    "admin.pending_reset": "Pending resets",
    "admin.loading": "Loading…",
    "admin.user": "User",
    "admin.status": "Status",
    "admin.registered": "Registered",
    "admin.active": "Active",
    "admin.edit": "Edit",
    "admin.reset_password": "Reset Password",
    "admin.no_users": "No registered users.",
    "admin.forgot_requests": "Forgot Password Requests",
    "admin.email": "Email",
    "admin.date": "Date",
    "admin.action": "Action",
    "admin.pending": "Pending",
    "admin.completed": "Completed",
    "admin.assign_password": "Assign Password →",
    "admin.no_requests": "No pending requests.",
    "admin.role_user": "User",
    "admin.role_admin": "Administrator",
    "admin.subscription_end": "Subscription End Date (optional)",
    "admin.account_active": "Account active",
    "admin.new_password": "New Password",
    "admin.assign": "Assign Password",
    "admin.assigning": "Resetting…",

    // Profile
    "profile.title": "Account Profile",

    "profile.full_name": "Full Name",
    "profile.role": "Role",
    "profile.email": "Email",
    "profile.timezone": "Time Zone",

    "profile.subtitle": "Manage personal information and security settings",
    "profile.loading": "Loading…",
    "profile.joined": "Joined",
    "profile.personal": "Personal Information",
    "profile.email_locked": "Email (cannot be changed)",
    "profile.local_time": "Current local time",
    "profile.save": "Save",
    "profile.saving": "Saving…",
    "profile.change_password": "Change Password",
    "profile.current_password": "Current Password",
    "profile.new_password": "New Password",
    "profile.confirm_password": "Confirm New Password",
    "profile.password_hint": "Minimum 6 characters. You do not need to sign in again after changing it.",
    "profile.update_password": "Update Password",
    "profile.updating": "Updating…",

    // Login/Register
    "auth.login_tab": "Sign In",
    "auth.register_tab": "Register",
    "auth.forgot_tab": "Forgot Password",
    "auth.hero": "Engineering instead of pallet planning.",
    "auth.hero_desc": "Use fewer pallets, maximize fill rate and achieve accurate physical layouts for your TV screen protector exports.",
    "auth.forgot": "Forgot Password?",
    "auth.new_account": "New Account",
    "auth.free_try": "Try for Free",
    "auth.password": "Password",
    "auth.password_again": "Confirm Password",
    "auth.create_account": "Create Account",
    "auth.creating": "Creating…",
    "auth.terms": "By continuing, you agree to the Terms of Use.",
    "auth.recovery": "Password Recovery",
    "auth.recovery_desc": "Enter your email address. An administrator will contact you.",
    "auth.request_received": "Your request has been received. An administrator will reset your password shortly.",
    "auth.send_request": "Send Request",
    "auth.sending": "Sending…",
    "auth.sent": "Sent ✓",
    "auth.back_login": "← Back to sign in",
    "auth.google": "Sign in with Google",

    // Reset / Verify
    "reset.title": "Password Reset",
    "reset.new_password": "Set New Password",
    "reset.desc": "Enter your new password below. It must be at least 6 characters.",
    "reset.invalid": "The reset link is invalid.",
    "reset.success": "Your password has been updated successfully. Redirecting to sign in…",
    "reset.update": "Update Password",
    "reset.back": "Back to Sign In",

    "verify.title": "Email Verification",
    "verify.verifying": "Verifying email…",
    "verify.success": "Your email has been verified!",
    "verify.activated": "your account has been activated. You can now sign in.",
    "verify.redirect": "Redirecting automatically…",
    "verify.failed": "Verification Failed",
    "verify.back": "Back to Sign In",

    // Components
    "layer.show_all": "Show All",
    "layer.total_h": "Total H",
    "layer.total_kg": "Total KG",
    "layer.show_3d": "Show in 3D",
    "layer.hide_3d": "Hide in 3D",
    "layer.no_boxes": "No boxes yet",
    "layer.top_view": "Layer Top View",
    "layer.click_box": "Click a box",

    "pallet3d.drag_on": "🎯 DRAGGING ON",
    "pallet3d.drag": "Drag & Drop",
    "pallet3d.height": "Height",
    "pallet3d.weight": "Weight",

    "upgrade.quota_full": "Monthly Quota Reached",
    "upgrade.title": "Upgrade to Pro & Create Unlimited Plans",
    "upgrade.current_plan": "Current plan",
    "upgrade.recipe": "Recipe library",
    "upgrade.unlimited": "Unlimited plans",
    "upgrade.priority": "Priority support",
    "upgrade.recommended": "Recommended",
    "upgrade.button": "Upgrade to Pro",
    "upgrade.later": "Remind me later",

    "sidebar.management": "Management",

    "final.loading": "Loading",
    "final.save": "Save",
    "final.cancel": "Cancel",
    "final.delete_success": "Deleted",
    "final.delete_confirm": "Delete this item?",
    "final.download_failed": "Download failed",

    "final.profile_name_required": "Name cannot be empty",
    "final.profile_updated": "Profile updated",
    "final.all_fields": "Fill in all fields",
    "final.password_min": "New password must be at least 6 characters",
    "final.password_mismatch": "New passwords do not match",
    "final.password_updated": "Password updated",

    "final.test_need_product": "Enter at least one product",
    "final.test_pallet_type": "Pallet Type",
    "final.test_expected": "Expected Pallet Count",
    "final.test_comparing": "Comparing",
    "final.selected": "selected",

    "final.reset_invalid_token": "Invalid reset link — token is missing.",
    "final.reset_min": "Password must be at least 6 characters",
    "final.reset_mismatch": "Passwords do not match",
    "final.reset_done": "Your password has been updated",

    "final.google_success": "Signed in with Google successfully",
    "final.google_failed": "Google sign-in failed",
    "final.google_verifying": "Verifying Google session…",

    "final.admin.password_min": "Password must be at least 6 characters",
    "final.admin.end": "Expires",
    "final.admin.assign": "Assign Password →",
    "final.admin.edit": "Edit",
    "final.admin.active": "Account active",
    "final.admin.cancel": "Cancel",
    "final.admin.save": "Save",
    "final.admin.reset": "Reset Password",

    "final.recipe_delete": "Delete this recipe?",

    "final.invoice.cancel": "Cancel Invoice",
    "final.invoice.cancelled_info": "This invoice has been cancelled.",
    "final.invoice.copy_hint": "Use the Copy option to create a new document.",
    "final.invoice.mixed_currency": "Mixed currency",
    "final.invoice.description": "Description",
    "final.invoice.edit_no": "Edit invoice number",
    "final.invoice.product_management": "Product Management",
    "final.invoice.missing_prices": "Some products do not have a price.",
    "final.invoice.enter_prices": "page to enter unit prices.",

    "final.dashboard.quota_full": "Monthly plan quota reached",
    "final.dashboard.free_quota": "Free Plan Quota",
    "final.dashboard.this_month": "This month",
    "final.dashboard.used": "plans used",
    "final.dashboard.pro_hint": "Upgrade to Pro for unlimited plans.",
    "final.dashboard.upgrade": "Upgrade to Pro",

    "final.verify_missing": "Verification token is missing.",
    "final.verify_failed": "Verification failed.",
    "final.verify.for": "for",

    "final.login_success": "Signed in successfully",
    "final.login_min": "Password must be at least 6 characters",
    "final.login_mismatch": "Passwords do not match",
    "final.login.request": "Request received",

    "final.products.new_category": "New category name:",
    "final.products.select_category": "Select a category first",
    "final.products.category_name": "Category name:",
    "final.products.updated": "Category updated",
    "final.products.select_product": "Select at least one product",
    "final.products.edit": "Edit",
    "final.products.package_kg": "Package kg",
    "final.products.product_kg": "Product kg",
    "final.products.net_kg": "Net kg",
    "final.products.unit_price": "Unit Price (for Commercial Invoice)",
    "final.products.select_all": "Select all products",

    "final.layer.show_all": "Show All",

    "final.pallet3d.drag_on_title": "Drag & drop enabled — click to disable",
    "final.pallet3d.drag_title": "Drag boxes on the XY plane",
    "final.pallet3d.box": "Box",

    "final.upgrade.desc": "Your free plan has a limited monthly plan quota. Upgrade to Pro for unlimited plans, recipe suggestions and all features.",



    "final4b.newplan.match_exact": "Exact Match",
    "final4b.newplan.match_multiple": "Multiple Match",
    "final4b.newplan.match_partial": "Partial Match",
    "final4b.newplan.recipe_apply": "Recipe will be applied",
    "final4b.newplan.press_optimize": "press Optimize",
    "final4b.newplan.recipes_applied": "recipes applied",
    "final4b.newplan.optimization_done": "Optimization completed",
    "final4b.newplan.reopt_confirm": "This plan will be re-optimized with the new quantities and OVERWRITTEN. Continue?",
    "final4b.newplan.plan_updated": "Plan updated",
    "final4b.newplan.suitable_count": "Approved recipes suitable for this order",
    "final4b.newplan.best_match": "Best match",
    "final4b.newplan.inspect": "Inspect →",
    "final4b.newplan.enter_qty": "Enter product quantities and press",
    "final4b.newplan.press_button": ".",
    "final4b.newplan.reoptimize": "Re-optimize",
    "final4b.newplan.optimize": "Optimize",
    "final4b.newplan.save_open": "Save Plan & Open Details",
    "final4b.newplan.recipe": "Recipe",
    "final4b.newplan.consumed": "To be consumed",

    "final4b.detail.loading": "Loading",
    "final4b.detail.undo_none": "Nothing to undo",
    "final4b.detail.rotation_not_fit": "The box does not fit on the pallet after rotation",
    "final4b.detail.rotation_no_space": "No suitable position found after rotation",
    "final4b.detail.outside": "Outside pallet boundaries",
    "final4b.detail.collision": "Collides with another box",
    "final4b.detail.target_not_fit": "Does not fit on the target pallet",
    "final4b.detail.box_moved": "Box moved",
    "final4b.detail.remove_box_confirm": "Remove this box from the pallet?",
    "final4b.detail.only_empty": "Only empty pallets can be deleted",
    "final4b.detail.delete_pallet": "pallet be deleted?",
    "final4b.detail.pallet_deleted": "Pallet deleted",
    "final4b.detail.orientation_default": "L×W×H (default)",
    "final4b.detail.orientation_side": "L×H×W (side)",
    "final4b.detail.orientation_rotated": "W×L×H (rotated)",
    "final4b.detail.select_product_error": "Select a product",
    "final4b.detail.product_not_found": "Product not found",
    "final4b.detail.no_rotation_fit": "The box does not fit in any of the 6 rotations — add a new pallet",
    "final4b.detail.try_other": "does not fit in this orientation; try another orientation or select Automatic",
    "final4b.detail.box_added": "Box added",
    "final4b.detail.box_positioned": "Box moved to the new position",
    "final4b.detail.boxes_rotated": "boxes rotated (Z axis)",
    "final4b.detail.save_first": "Save your changes first",
    "final4b.detail.approved": "Plan approved and saved as a Recipe",
    "final4b.detail.manual_saved": "Manual changes saved",
    "final4b.detail.save": "Save",
    "final4b.detail.empty": "Empty",
    "final4b.detail.delete_empty": "Delete empty pallet",
    "final4b.detail.mouse_help": "Click a box · Shift/Ctrl + click for multi-select · Drag with mouse to rotate",
    "final4b.detail.pallet": "Pallet",
    "final4b.detail.boxes_selected": "boxes selected",
    "final4b.detail.bulk_rotate": "Rotate Selected (Z)",
    "final4b.detail.clear_selection": "Clear Selection",
    "final4b.detail.metrics": "Pallet Metrics",
    "final4b.detail.pallet_no": "Pallet No",
    "final4b.detail.box": "Box",
    "final4b.detail.height": "Height",
    "final4b.detail.weight": "Weight",
    "final4b.detail.empty_volume": "Empty Volume",
    "final4b.detail.selected_box": "Selected Box",
    "final4b.detail.rotate": "Rotate (90°)",
    "final4b.detail.move_position": "Move Position",
    "final4b.detail.move_pallet": "Move to Another Pallet",
    "final4b.detail.select_target": "Select target",
    "final4b.detail.delete_box": "Delete Box",
    "final4b.detail.select_box_manual": "Select a box to edit manually",
    "final4b.detail.orientation": "Orientation (Rotation)",
    "final4b.detail.auto_help": "The system places the box at the first suitable empty position. When Automatic is selected, all 6 orientations are tried in sequence.",
    "final4b.detail.box_list": "Box List",
    "final4b.detail.add_pallet": "Add New Pallet",
    "final4b.detail.select_pallet_type": "Select a pallet type (usable height is taken into account):",
    "final4b.detail.plan_default": "Plan Default",
    "final4b.detail.usable": "usable",
    "final4b.detail.no_pallet_type": "No pallet type found",

    "final4b.detail.bulk_delete": "Delete Selected",
    "final4b.detail.summary": "Product Counts on This Pallet",
    "final4b.detail.add_box": "Add Box to This Pallet",
    "final4b.detail.download_failed": "Download failed",
    "final4b.detail.automatic": "Automatic",
    "final4b.newplan.recipe_badge": "RCP",
    "final4b.newplan.consignee_example": "e.g. ACME Ltd. — London Branch",




    "landing.nav.home": "Home",
    "landing.nav.features": "Features",
    "landing.nav.how": "How It Works",
    "landing.nav.sectors": "Industry Solutions",
    "landing.nav.pricing": "Pricing",
    "landing.nav.demo": "Demo",
    "landing.nav.about": "About",
    "landing.nav.contact": "Contact",

    "landing.theme": "Toggle theme",
    "landing.login": "Sign In",
    "landing.free_try": "Try for Free",

    "landing.hero.badge": "H3POE Algorithm · 3D Physical Layout",
    "landing.hero.title1": "Engineering instead of",
    "landing.hero.title2": "pallet planning.",
    "landing.hero.desc": "Use fewer pallets, maximize fill rate and achieve accurate physical layouts for your TV screen protector exports. Enter the order and let the system generate everything through to PDF.",
    "landing.hero.try": "Try for Free",
    "landing.hero.demo": "Watch Demo",
    "landing.hero.fit": "✓ Fit Into 3 Pallets",

    "landing.features.eyebrow": "Features",
    "landing.features.title": "Every step of export, on one platform",
    "landing.features.h3poe.title": "H3POE Optimization Engine",

    "landing.features.docs.text2": "Professional Packing List and Commercial Invoice templates with UTF-8, currency support and QR-coded pallets.",
    "landing.features.test.text2": "Measure algorithm accuracy against previous shipments, report differences and continuously improve.",

    "landing.sectors.electronics.title2": "Electronics & Consumer Goods",
    "landing.sectors.electronics.text2": "TV screen protectors, tablets and equipment with fragility controls and stacking-support calculations.",
    "landing.sectors.retail.text2": "Mixed-SKU pallets. Plan store orders in seconds using the recipe system.",
    "landing.sectors.factory.title2": "Manufacturing & Factory",
    "landing.sectors.factory.text2": "Move directly from production output to export with bulk Excel imports and inventory synchronization.",
    "landing.sectors.export.text2": "UK/USA + EU pallet types, INCOTERMS and Consignee support, ready for container planning.",

    "landing.about.p2b": "Our team developed an Extreme Point based 3D bin-packing engine and recipe-based recommendation system using real shipment data. The system is designed to significantly accelerate pallet planning.",

    "landing.contact.address_value": "Maslak Mah. Buyukdere Cad., Istanbul",

    "landing.features.h3poe.text": "Extreme Point based 3D bin packing, 4 strategy comparisons and 6 rotation attempts. Fewer pallets, higher fill rate.",
    "landing.features.recipe.title": "Recipe System",
    "landing.features.recipe.text": "Approved plans become reusable recipes and can be applied instantly when the same order returns.",
    "landing.features.docs.title": "Export Documents",
    "landing.features.docs.text": "Professional Packing List and Commercial Invoice templates with UTF-8, currency support and QR-coded pallets.",
    "landing.features.test.title": "Test Center",
    "landing.features.test.text": "Measure algorithm accuracy against previous shipments, report differences and continuously improve.",
    "landing.features.manual.title": "Manual 3D Editor",
    "landing.features.manual.text": "Drag and drop, lock boxes, hide layers and use multi-select for bulk rotate and delete actions.",
    "landing.features.fx.title": "Automatic Exchange Rates",
    "landing.features.fx.text": "Automatically convert invoice prices using TCMB rates and receive mixed-currency warnings.",

    "landing.how.eyebrow": "How It Works",
    "landing.how.title": "Export-ready in 4 steps",
    "landing.how.1.title": "Enter Your Order",
    "landing.how.1.text": "Enter products and quantities, then select the pallet type.",
    "landing.how.2.title": "Optimize",
    "landing.how.2.text": "The H3POE algorithm generates the 3D physical layout in seconds.",
    "landing.how.3.title": "Review & Edit",
    "landing.how.3.text": "Review the 3D layout and make manual adjustments with drag and drop.",
    "landing.how.4.title": "Export PDF/Excel",
    "landing.how.4.text": "Download Packing Lists, Commercial Invoices and QR-code labels.",

    "landing.sectors.eyebrow": "Industry Solutions",
    "landing.sectors.title": "Built for every export operation",
    "landing.sectors.electronics.title": "Electronics & Consumer Goods",
    "landing.sectors.electronics.text": "TV screen protectors, tablets and equipment with fragility controls and stacking-support calculations.",
    "landing.sectors.retail.title": "Retail & Distribution",
    "landing.sectors.retail.text": "Mixed-SKU pallets. Plan store orders in seconds using reusable recipes.",
    "landing.sectors.factory.title": "Manufacturing & Factory",
    "landing.sectors.factory.text": "From production output directly to export, with bulk Excel imports and inventory synchronization.",
    "landing.sectors.export.title": "Export & Logistics",
    "landing.sectors.export.text": "UK/USA + EU pallet types, INCOTERMS and Consignee support, ready for container planning.",

    "landing.pricing.eyebrow": "Pricing",
    "landing.pricing.title": "Fair pricing per user",
    "landing.pricing.free": "Starter",
    "landing.pricing.free_price": "₺0",
    "landing.pricing.free_period": "Free",
    "landing.pricing.free_f1": "1 active plan/month",
    "landing.pricing.free_f2": "1 user",
    "landing.pricing.free_f3": "PDF export",
    "landing.pricing.free_f4": "TR interface",
    "landing.pricing.free_cta": "Try for Free",
    "landing.pricing.pro_f1": "Unlimited plans",
    "landing.pricing.pro_f2": "5 users",
    "landing.pricing.pro_f3": "Commercial Invoice",
    "landing.pricing.pro_f4": "QR codes & TCMB rates",
    "landing.pricing.pro_f5": "Recipe system",
    "landing.pricing.pro_f6": "Priority support",
    "landing.pricing.pro_cta": "Get Started",
    "landing.pricing.enterprise": "Enterprise",
    "landing.pricing.custom": "Custom",
    "landing.pricing.quote": "Quote",
    "landing.pricing.ent_f1": "Unlimited users",
    "landing.pricing.ent_f2": "Your own domain",
    "landing.pricing.ent_f3": "SSO/SAML",
    "landing.pricing.ent_f4": "API access",
    "landing.pricing.ent_f5": "Custom training",
    "landing.pricing.ent_cta": "Contact Us",
    "landing.pricing.popular": "Popular",

    "landing.demo.eyebrow": "Demo",
    "landing.demo.title": "See it for yourself",
    "landing.demo.open": "Open Demo",

    "landing.about.eyebrow": "About",
    "landing.about.title": "Pallet planning should not still live in Excel",
    "landing.about.p1": "H3POE was built to accelerate export operations. Manual pallet planning can take hours and introduce operational errors.",
    "landing.about.p2": "An Extreme Point based 3D bin-packing engine and recipe-based recommendation system can significantly speed up planning using real shipment data.",
    "landing.about.metric1": "Pallets Optimized",
    "landing.about.metric2": "Avg. Plan Time",
    "landing.about.metric3": "Active Companies",

    "landing.contact.eyebrow": "Contact",
    "landing.contact.title": "Write to us with your questions",
    "landing.contact.address": "Address",
    "landing.contact.support": "Live Support",
    "landing.contact.support_hours": "Mon-Fri 09:00-18:00",

    "landing.footer.rights": "All rights reserved.",

    "landing.form.name": "Your name",
    "landing.form.message": "Your message",
    "landing.form.sent": "Message Received ✓",
    "landing.form.send": "Send",


    // Plan Detail
    "plandetail.dirty": "Unsaved changes",
    "plandetail.approve_recipe": "Approve & Recipe",
    "plandetail.create_invoice": "Create Invoice",
    "plandetail.pallets": "Pallets",
    "plandetail.new_pallet": "New Pallet",
    "plandetail.add_box": "Add Box to This Pallet",
    "plandetail.select_product": "Select a product…",
    "plandetail.summary": "Product Counts on This Pallet",
    "plandetail.hint_click": "Click a box · Shift/Ctrl + click for multi-select · Rotate with mouse",
    "plandetail.selected_boxes": "{n} boxes selected",
    "plandetail.bulk_rotate": "Bulk Rotate (Z)",
    "plandetail.bulk_delete": "Bulk Delete",
    "plandetail.clear_selection": "Clear Selection",
  },
};

const LangCtx = createContext({ lang: "tr", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("pallet_lang") || "tr"; } catch (_) { return "tr"; }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("pallet_lang", l); } catch (err) { console.warn("lang persist failed:", err); }
  }, []);
  const t = useCallback((key, vars) => {
    const dict = DICT[lang] || DICT.tr;
    let s = dict[key] ?? DICT.tr[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
      }
    }
    return s;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export function useI18n() {
  return useContext(LangCtx);
}
